import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../AuthContext";
import { formatApiError } from "../api";

const REMEMBER_KEY = "ok_remember_email";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);

  // Restore remembered email on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem(REMEMBER_KEY);
      if (saved) {
        setEmail(saved);
        setRemember(true);
      }
    } catch (_) { /* ignore */ }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      try {
        if (remember) localStorage.setItem(REMEMBER_KEY, email);
        else localStorage.removeItem(REMEMBER_KEY);
      } catch (_) { /* ignore */ }
      const dest = u.role === "admin" ? "/admin" : u.role === "candidate" ? "/kandidaat-dashboard" : "/inlener-dashboard";
      toast.success("Welkom terug!");
      nav(dest);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Inloggen mislukt");
    }
    setBusy(false);
  };

  return (
    <section className="ok-section">
      <div className="ok-container max-w-md">
        <div className="ok-eyebrow mb-3">Inloggen</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">Welkom terug.</h1>
        <p className="text-[#4a5d5e] mt-3">Toegang tot je dashboard, sollicitaties en voorstellen.</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-wider font-semibold text-[#4a5d5e] mb-2">E-mailadres</label>
            <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 border border-[#e2e8f0] text-sm bg-white" autoComplete="email" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider font-semibold text-[#4a5d5e] mb-2">Wachtwoord</label>
            <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 border border-[#e2e8f0] text-sm bg-white" autoComplete="current-password" />
          </div>
          <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
            <input
              data-testid="login-remember"
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              className="w-4 h-4 accent-[#01696f]"
            />
            <span>Onthoud mijn gegevens</span>
          </label>
          <button data-testid="login-submit" disabled={busy}
            className="w-full bg-[#01696f] text-white py-3 rounded-sm hover:bg-[#015257] disabled:opacity-60 font-medium">
            {busy ? "Bezig..." : "Inloggen"}
          </button>
        </form>
        <div className="mt-8 text-sm text-[#4a5d5e] space-y-1">
          <p>Nieuw bij Overheidskrachten?</p>
          <Link to="/aanmelden-kandidaat" className="text-[#01696f] font-semibold block">→ Aanmelden als kandidaat</Link>
          <Link to="/aanmelden-inlener" className="text-[#01696f] font-semibold block">→ Aanmelden als inlener</Link>
        </div>
      </div>
    </section>
  );
}
